import type { FC, SVGAttributes } from 'react'
import React from 'react'

import createComponent from '../../../styles-system/create-component'
import type { BaseElementProps } from '../_types/baseTypes'

type CircleProps = BaseElementProps<SVGCircleElement> &
  SVGAttributes<SVGCircleElement> & {
    __css?: object
  }

const Component = createComponent('circle', 'csg-circle')

const Circle: FC<CircleProps> = React.forwardRef<SVGCircleElement, CircleProps>(
  function Circle(props, ref) {
    return <Component ref={ref} {...props} />
  }
)

export default Circle
